import axios from 'axios';
import * as Constants from './configuration';

export function getSellersList(
  regionCode,
  pageNumber,
  pageSize,
  status,
  customHeaders = {}
) {
  return (dispatch) =>
    axios({
      method: 'GET',
      url: `${Constants.USER_SERVICE_URL}/users?status=${status}&regions=${regionCode}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
      headers: {
        'Content-Type': 'application/json',
        ...customHeaders
      }
    })
      .then((response) => {
        dispatch({
          type: 'GET_SELLERS_LIST',
          payload: response.data
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error?.response
        });
      });
}
